export const PRIORITY_QUEUE_ANALYTICS = {
  toggled: 'Priority Queue Filter Toggled',
  nextUpPressed: 'Priority Queue Next Up Pressed',
} as const
